import { FC, createContext, useContext, useEffect, useState } from 'react';
import UserContext from 'src/context/UserContext';
import { Role } from 'src/Role';
import { BillingApi } from 'src/features/billing/billingApi';
import { NavBadge } from './navigation';

const REFRESH_MS = 60000;

/** Roles allowed to read the bank transfer queue (the API refuses everyone else). */
const BANK_TRANSFER_REVIEWERS: string[] = [Role.SUPER_ADMIN, Role.CUSTOMER_SUPPORT];

type NavBadges = Partial<Record<NavBadge, number>>;

const NavBadgesContext = createContext<NavBadges>({});

/** Live counters shared by the sidebar badges and the header notifications. */
export const NavBadgesProvider: FC = ({ children }) => {
  const [user] = useContext(UserContext);
  const [pendingBankTransfers, setPending] = useState(0);
  const enabled = !!user?.role && BANK_TRANSFER_REVIEWERS.includes(user.role);

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    const load = async () => {
      const res = await BillingApi.pendingBankTransferCount();
      if (active && res.success && res.data) setPending(res.data.count);
    };
    load();
    const timer = window.setInterval(load, REFRESH_MS);
    return () => {
      active = false;
      window.clearInterval(timer);
    };
  }, [enabled]);

  return <NavBadgesContext.Provider value={{ pendingBankTransfers }}>{children}</NavBadgesContext.Provider>;
};

export const useNavBadges = () => useContext(NavBadgesContext);
